import React, { useContext } from "react"

import MobileDropdown from "./MobileDropdown"
import MobileIcon from "./MobileIcon"
import MobileItem from "./MobileItem"

import { isConstructorType } from "../../../utils"
import { DrawerContext } from "../../../contexts"

import {
  DrawerCloseButton,
  DrawerOverlay,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  Heading,
  Drawer,
  VStack,
  Flex,
} from "@chakra-ui/react"

export default function MobileMenu({ menu }) {
  const { isOpen, onClose } = useContext(DrawerContext)

  return (
    <Drawer isOpen={isOpen} placement="right" onClose={onClose}>
      <DrawerOverlay>
        <DrawerContent
          height="calc(100vh - calc(100vh - 100%))!important"
          position="relative"
          overflowY="scroll"
          overflowX="hidden"
          bg="base.d200"
        >
          <DrawerHeader
            as={Flex}
            justifyContent="space-between"
            position="relative"
            alignItems="center"
            minHeight="50px"
            py={0}
            px={4}
          >
            <Heading size="xl" lineHeight={1} fontWeight="semibold">
              Menu
            </Heading>
            <DrawerCloseButton />
          </DrawerHeader>

          <VStack spacing={2} py={4} px={0}>
            {menu.map(({ icon, label, url }, index) => {
              const props = {
                label,
                url,
              }

              return isConstructorType("string", url) ? (
                <MobileItem key={index} {...props}>
                  <MobileIcon icon={icon} />
                </MobileItem>
              ) : (
                <MobileDropdown key={index} {...props}>
                  <MobileIcon icon={icon} />
                </MobileDropdown>
              )
            })}
          </VStack>

          <DrawerFooter></DrawerFooter>
        </DrawerContent>
      </DrawerOverlay>
    </Drawer>
  )
}
